<template>
  <div class="gender-setting">
    {{ $t("gender") }}

    <div class="gender-types">
      <div class="gender"
           :class="{ 'selected': gender === male }"
           @click="$emit('genderChange', male)">
        {{ male }}
      </div>
      <div class="gender"
           :class="{ 'selected': gender === female }"
           @click="$emit('genderChange', female)">
        {{ female }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      gender: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        male: 'M',
        female: 'F'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gender-setting {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 14px 0 14px 0;
    border-bottom: 1px solid #f2f2f2;

    .gender-types {
      width: 70px;
      display: flex;
      justify-content: space-between;

      .gender {
        width: 30px;
        height: 30px;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        background: #f2f2f2;
        border-radius: 50%;
      }

      .selected {
        background: map-get($colors, secondary);
      }
    }
  }
</style>

